import { createDefaultTyrann } from '@apis/common';
import { patchRoutePlan, postRoutePlan, routePlan, routePlanQuery } from '@models/RoutePlan';
import * as t from 'io-ts';

export const routePlanApis = createDefaultTyrann({
  '/dashboard/route-plan/': {
    get: {
      query: routePlanQuery,
      response: {
        200: t.array(routePlan),
      },
    },
    post: {
      body: postRoutePlan,
      response: {
        201: routePlan,
      },
    },
  },
  '/dashboard/route-plan/{id}/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: routePlan,
      },
    },
    patch: {
      path: t.type({
        id: t.number,
      }),
      body: patchRoutePlan,
      response: {
        200: routePlan,
        400: t.type({}),
      },
    },
    delete: {
      path: t.type({
        id: t.number,
      }),
      response: {
        204: t.unknown,
      },
    },
  },
});
